import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';
import { ServiceAftaleService } from 'src/app/api/services';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { FastOrdreNoteDialogData } from '../../models';

@Component({
    selector: 'app-fast-ordre-note-edit',
    templateUrl: './fast-ordre-note-edit-dialog.component.html',
    styleUrls: ['./fast-ordre-note-edit-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FastOrdreNoteEditDialogComponent implements OnInit {
  form: UntypedFormGroup;
  unsubscribe$ = new Subject<void>();

  get fastOrdreNote() {
    return this.form.get('fastOrdreNote');
  }

  constructor(
    private serviceAftaleService: ServiceAftaleService,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
    private fb: UntypedFormBuilder,
    private dialog: MatDialogRef<FastOrdreNoteEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FastOrdreNoteDialogData
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      fastOrdreNote: [this.data.serviceaftale.fastOrdreNote, [Validators.maxLength(500)]],
    });
  }

  save() {
    this.loader.show();
    this.serviceAftaleService
      .updateFastOrdreNote({
        caller: EGIS_SERVICE_CALLER,
        body: {
          serviceaftaleId: this.data.serviceaftale.id,
          fastOrdreNote: this.fastOrdreNote.value,
          rowVersion: this.data.serviceaftale.rowVersion,
        },
      })
      .pipe(
        tap(() => {}),
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(
        (serviceaftale) => {
          this.dialog.close(serviceaftale);
        },
        (error) => {
          this.errorHandler.HandleError(error);
        }
      );
  }

  cancel() {
    this.dialog.close(null);
  }
}
